import { UnitListingDetailsModel } from 'src/api/models';
import {
  HousePageTabs,
  HOUSE_PAGE_TABS,
  ALLOWED_TABS_WHEN_LOVE,
} from './constants';

export function getAvailableTabs(
  home: UnitListingDetailsModel,
  isPreview: boolean,
  hasRoomsPhotos: boolean,
) {
  const {
    basicInfo,
    listingInfo,
    virtual3DTourProvider,
    virtual3DTourId,
    guidedTour,
  } = home;

  // `mediaAvailable` is optional on the model, so it needs the same `?.` the
  // surrounding `basicInfo` reads already use — a home without it would throw
  // here rather than fall through to "no tabs available".
  const availableMedia = {
    [HousePageTabs.ExteriorPhotos]: basicInfo?.mediaAvailable?.includes(
      HousePageTabs.ExteriorPhotos,
    ),
    [HousePageTabs.RoomsPhotos]:
      hasRoomsPhotos &&
      basicInfo?.mediaAvailable?.includes(HousePageTabs.RoomsPhotos),
    [HousePageTabs.Virtual3DTour]: !!(
      basicInfo?.mediaAvailable?.includes(HousePageTabs.Virtual3DTour) &&
      virtual3DTourProvider &&
      virtual3DTourId
    ),
    [HousePageTabs.GuidedTour]:
      !!basicInfo?.mediaAvailable?.includes(HousePageTabs.GuidedTour) &&
      guidedTour?.url,
    [HousePageTabs.StreetView]: basicInfo?.mediaAvailable?.includes(
      HousePageTabs.StreetView,
    ),
    [HousePageTabs.Map]: basicInfo?.mediaAvailable?.includes(HousePageTabs.Map),
  };

  // Coming Soon homes are pre-Full-Listing-Published, so isAvailableForRent is always false for
  // them — gating on it alone narrowed their cover to ALLOWED_TABS_WHEN_LOVE and dropped the
  // Rooms, 3D Tour and Virtual Tour tabs, giving a published listing the "loved"/rented treatment
  // even though the rest of the page already exposes that same media (LOVE-335).
  const isPublishedListing = !!(
    listingInfo?.isAvailableForRent || listingInfo?.isComingSoon
  );

  return (
    (Object.keys(availableMedia) as (keyof typeof availableMedia)[])
      .filter(
        (key) =>
          availableMedia[key] &&
          (isPreview ||
            isPublishedListing ||
            ALLOWED_TABS_WHEN_LOVE.includes(key)),
      )
      .map((media) =>
        Object.values(HOUSE_PAGE_TABS).find((tab) => tab.mediaName === media),
      )
      // A miss is impossible — every key above is some tab's `mediaName` — but
      // spreading the `find` result to drop it is what erased the tab type to
      // `{}`, so every `tab.key` / `tab.text` read at the call sites errored.
      .filter((tab) => tab !== undefined)
  );
}
